import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const CALL_TO_ACTION_URL = 'https://posy.cl';

const Banner = ({ visible }) => {
  const { t } = useTranslation();

  if (!visible) {
    return null;
  }

  return (
    <div className="relative z-50 t-0 isolate flex items-center overflow-hidden bg-gray-50 px-4 py-3 sm:px-3.5 sm:before:flex-1">
      <div
        className="absolute left-[max(-7rem,calc(50%-52rem))] top-1/2 -z-10 -translate-y-1/2 transform-gpu blur-2xl"
        aria-hidden="true"
      >
        <div
          className="aspect-[577/310] w-[36.0625rem] bg-gradient-to-r from-[#ff80b5] to-[#9089fc] opacity-30"
          style={{
            clipPath:
              'polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)',
          }}
        />
      </div>
      <div
        className="absolute left-[max(45rem,calc(50%+8rem))] top-1/2 -z-10 -translate-y-1/2 transform-gpu blur-2xl"
        aria-hidden="true"
      >
        <div
          className="aspect-[577/310] w-[36.0625rem] bg-gradient-to-r from-[#ff80b5] to-[#9089fc] opacity-30"
          style={{
            clipPath:
              'polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)',
          }}
        />
      </div>
      <div className="flex items-center gap-x-4 gap-y-2 w-full">
        <div className="flex items-center w-full flex-1">
          <img src="/favicon.ico" className="h-8 w-8" />
          <p className="text-sm leading-6 text-gray-900 ml-3">
            {t('createCatalogBanner.title')}
          </p>
        </div>
        <a
          href={CALL_TO_ACTION_URL}
          className="flex-none rounded-full bg-gray-900 px-3.5 py-1 text-sm font-semibold text-white shadow-sm hover:bg-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900"
        >
          {t('createCatalogBanner.callToActionText')}
          <span aria-hidden="true" className="ml-1">
            &rarr;
          </span>
        </a>
      </div>
    </div>
  );
};

Banner.propTypes = {
  visible: PropTypes.bool,
};

export default Banner;
